import React, { useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import Onboarding from "./components/Onboarding";
import AboutUs from "./pages/AboutUs";
import ANDArenaLayout from "./pages/ANDArenaLayout";
import ANDCompeteNow from "./pages/ANDCompeteNow";
import ANDHomePage from "./pages/ANDHomePage";
import ANDLeaderBoard from "./pages/ANDLeaderBoard";
import ANDRulesAndSubmit from "./pages/ANDRulesAndSubmit";
import ArtistBooking from "./pages/ArtistBooking";
import ArtistProfile from "./pages/ArtistProfile"; // Create this new component
import ArtistsByCategory from "./pages/ArtistsByCategory";
import Blog from "./pages/Blog";
import ContactUs from "./pages/ContactUs";
import Contests from "./pages/Contests";
import Homepage from "./pages/homepage";
import Layout from "./pages/layout";
import LoginPage from "./pages/LoginPage";
import ParticipateInCategoryPage from "./pages/ParticipateInANDArenaPages/ParticipateInCategoryPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ArtistProfileDashboard from "./pages/Profiles/ArtistProfile";
import UserProfile from "./pages/Profiles/UserProfile";
import RefundPolicy from "./pages/RefundPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import VoteNowPage from "./pages/VoteNowPage";
import ProtectedRoute from "./ProtectedRoute";
import Feedback from "./pages/Feedback";
import { BlogPost } from "./pages/Blog/BlogPost";
import BlogCategory from "./pages/Blog/BlogCategory";
import BlogTag from "./pages/Blog/BlogTag";
import { ForgotPasswordFlow } from "./pages/ForgotPassword";
import ANDJobPosting from "./pages/ANDJobPosting";
import ANDJobListing from "./pages/ANDJobListing";
import ShippingPolicy from "./pages/ShippingPolicy";
import UserAccountPolicy from "./pages/UserAccountPolicy";
import ANDMarketPlace from "./pages/ANDMarketPlace";
import ArtworkDetail from "./pages/ANDMarketPlace/ArtworkDetail";
import ArtistPreviewProfile from "./pages/ArtistPreviewProfile";

function App() {
  const [activeSection, setActiveSection] = useState("intro");

  return (
    <Router>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route path="onboarding" element={<Onboarding />} />
          <Route
            path="dashboard/user"
            element={
              <>
                <Layout activeSection={activeSection}></Layout>
                <div style={{ marginTop: "80px" }}>
                  <UserProfile />
                </div>
              </>
            }
          />
          <Route
            path="dashboard/artist"
            element={
              <>
                <Layout activeSection={activeSection}></Layout>
                <div style={{ marginTop: "70px" }}>
                  <ArtistProfileDashboard />
                </div>
              </>
            }
          />
        </Route>
        <Route
          path="/"
          element={
            <Layout
              activeSection={activeSection}
              setActiveSection={setActiveSection}
            />
          }
        >
          {/* The index route is automatically rendered when the parent route ("/") is matched */}
          <Route
            index
            element={
              <Homepage
                activeSection={activeSection}
                setActiveSection={setActiveSection}
              />
            }
          />
          <Route path="booking/:artistUsername" element={<ArtistBooking />} />

          {/* Define the book comedian route */}
          <Route
            path="categories/:artistCategoryUrl"
            element={<ArtistsByCategory />}
          />

          <Route path="/buy-art" element={<ANDMarketPlace />} />
          <Route path="/buy-art/:username/:artId" element={<ArtworkDetail />} />

          <Route path="profile/:username" element={<ArtistProfile />} />
          <Route
            path="preview-profile/:username"
            element={<ArtistPreviewProfile />}
          />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/category/:category" element={<BlogCategory />} />
          <Route path="/blog/tag/:tag" element={<BlogTag />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/user-policy" element={<UserAccountPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/post-job" element={<ANDJobPosting />} />
          <Route path="/jobs" element={<ANDJobListing />} />

          {/* <Route path="/feedback" element={<Feedback />} />
          <Route path="/notifications" element={<Feedback />} /> */}
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/forgot-password" element={<ForgotPasswordFlow />} />
        </Route>
        {/* User Profile route outside Layout */}

        <Route
          path="artist-next-door-arena/leaderboard"
          element={
            <ANDArenaLayout>
              <ANDLeaderBoard />
            </ANDArenaLayout>
          }
        />
        <Route
          path="artist-next-door-arena/vote-now"
          element={
            <ANDArenaLayout>
              <VoteNowPage />
            </ANDArenaLayout>
          }
        />

        <Route
          path="artist-next-door-arena/contests"
          element={
            <ANDArenaLayout>
              <Contests />
            </ANDArenaLayout>
          }
        />
        <Route
          path="rules-for-participating"
          element={
            <ANDArenaLayout>
              <ANDRulesAndSubmit />
            </ANDArenaLayout>
          }
        />

        <Route
          path="artist-next-door-arena/compete"
          element={
            <ANDArenaLayout>
              <ANDCompeteNow />
            </ANDArenaLayout>
          }
        />

        <Route
          path="artist-next-door-arena/compete/:categoryName"
          element={
            <ANDArenaLayout>
              <ParticipateInCategoryPage />
            </ANDArenaLayout>
          }
        />

        <Route
          path="artist-next-door-arena"
          element={
            <ANDArenaLayout>
              <ANDHomePage />
            </ANDArenaLayout>
          }
        />

        <Route
          path="artist-next-door-arena/contests/:contestCategory"
          element={
            <ANDArenaLayout>
              <Contests />
            </ANDArenaLayout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
